import React, { useEffect } from 'react';
import Header from '../Components/Header';
import Home from '../Components/Home';
import ProjectComponent from '../Components/Projects';
import Footer from '../Components/Footer';

export default function IndexPage() {
  useEffect(() => {
    window.location.replace('https://new.bayun.id/');    
  }, []);
  return (
    <>
      <Header />
      <Home />
      <ProjectComponent />
      <Footer />
    </>
  );
}